"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageRequest = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var imports_1 = require("@lib/imports");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageCarryable_sidecar_1 = require("@voyage/entities/voyageCarryable-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageTilemap_sidecar_1 = require("../tilemap/voyageTilemap-sidecar");
var voyageMessageCrewCarry_1 = require("./voyageMessageCrewCarry");
var voyageMessageCrewCarry_sidecar_1 = require("./voyageMessageCrewCarry-sidecar");
var voyageMessageCrewCreate_1 = require("./voyageMessageCrewCreate");
var voyageMessageCrewCreate_sidecar_1 = require("./voyageMessageCrewCreate-sidecar");
var voyageMessageHostCommand_1 = require("./voyageMessageHostCommand");
var voyageMessageHostCommand_sidecar_1 = require("./voyageMessageHostCommand-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var voyageMessageSystemCreate_sidecar_1 = require("./voyageMessageSystemCreate-sidecar");
var namespace = 'request-gamestate';
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.RequestGamestate;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {};
    return d;
}
exports.read = read;
function test() {
    var ex = {};
    messageWriter_sidecar_1.messageWriter.test('request-gamestate', ex, write, read);
}
exports.test = test;
function process(m, isFromHost, multiId) {
    var msg = read(m);
    console.log(namespace, 'got sync request');
    if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
        // Send the rest of our gamestate after map is loaded
        console.log(namespace, 'sending sync request');
        // Starmap
        // let starmap = voyageStarmaps.get()
        // voyageMessageStarmapCreate.sendMessageWorldState(
        //   {
        //     seed: starmap.seed,
        //     ci: starmap.currentI,
        //     cj: starmap.currentJ,
        //   },
        //   multiId,
        // )
        // Load crew
        imports_1.l.forEach(diveCrew_sidecar_1.diveCrew.getAll(), function (c) {
            voyageMessageCrewCreate_sidecar_1.voyageMessageCrewCreate.sendMessageWorldState({
                crewId: c.id,
                energy: c.energy,
                hitpoints: c.hitpoints,
                i: c.i,
                j: c.j,
                method: voyageMessageCrewCreate_1.EVoyageCrewCreateMethod.Normal,
                team: c.team,
                type: c.type,
                heroType: diveCrew_hero_data_1.EDiveHeroSubtype.None,
                enemyType: '',
                name: c.name,
                title: c.title,
            }, multiId);
            // if (c.crewState && c.crewState.body) {
            //   let b = c.crewState.body
            //   voyageMessageCrewStyle.sendMessageAndImmediatelyExecute({
            //     crewId: c.id,
            //     body: b.body.idx,
            //     hair: b.hair.idx,
            //     head: b.head.idx,
            //     bodyColor: b.bodyColor,
            //     hairColor: b.hairColor,
            //     headColor: b.headColor,
            //   })
            // }
        });
        // Load equipment
        imports_1.l.forEach(voyageCarryable_sidecar_1.voyageCarryable.getAll(), function (c) {
            voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendMessageWorldState({
                carryId1: c.id,
                carryId2: 0,
                command: voyageMessageCrewCarry_1.EVoyageCrewCarryCommand.Create,
                crewId: c.crew ? c.crew.id : 0,
                i: c.tile ? c.tile.i : 0,
                j: c.tile ? c.tile.j : 0,
                type: c.type,
            }, multiId);
        });
        // Load systems
        imports_1.l.forEach(voyageTilemap_sidecar_1.voyageTilemap.get().systems, function (c) {
            assert_sidecar_1.assert.notNil(c.system);
            voyageMessageSystemCreate_sidecar_1.voyageMessageSystemCreate.sendMessageWorldState({
                i: c.i,
                j: c.j,
                key: c.system.key,
                systemId: c.system.id,
            }, multiId);
        });
        voyageMessageHostCommand_sidecar_1.voyageMessageHostCommand.sendMessageWorldState({
            command: voyageMessageHostCommand_1.EHostCommand.old_Resume,
        }, multiId);
        // Load other stuff?
    }
}
exports.process = process;
function sendMessageRequest(msg) {
    websockets_sidecar_1.websockets._sendMessageRequest(write, msg);
}
exports.sendMessageRequest = sendMessageRequest;
